<template>
  <div class="entry">
    <Quicksearch v-bind:searching.sync="searching" v-bind:callback="callback"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">      
        <transition name="container-overlay">
            <div class="container-overlay" v-if="searching"></div>      
        </transition>

        <div v-if="data && data.Contribution.Status == 'Draft'" class="container container-small">
            <div class="statecontainer" :class="`statecontainer statecontainer-${data.Contribution.Status}`">
                <p v-html="$root.t(`editor:visibility:${data.Contribution.Status}`)"></p>
            </div>  
        </div>
        <template v-if="$route.params.view === 'Person'">
                <div class="container container-small" v-if="data">   
                    <div class="entry-float entry-float-sidebar">
                        <Literaturschweiz v-bind:term="$root.j([$root.try(data.Data, 'vorname'), $root.try(data.Data, 'name')], '+')"/>
                        <Integrations v-if="data.Data.integration" v-bind:values="data.Data.integration.Content"/>
                    </div>
                    <div class="entry-float entry-float-maincontent">
                        <h1 v-html="$root.j([$root.try(data.Data, 'vorname'), $root.try(data.Data, 'name')], ' ')"></h1>

                        <table class="entry-table">
                            <tr  v-if="data.Data.foto && data.Data.foto.Content && data.Data.foto.Content[0]">
                                <td>
                                    <figure>
                                        <img :src="data.Data.foto.Content[0].Files.Resized[0]"/>
                                    </figure>
                                </td>
                                <td>
                                    <div v-if="data.Data.foto.Content[0].Captions" class="entry-float-title" v-html="data.Data.foto.Content[0].Captions"></div>
                                </td>                                
                            <tr>
                            <tr v-if="data.adresse">
                                <td v-html="$root.t(`fieldlabel:adresse`)"></td>
                                <td>
                                    {{data.Data.strasse.Content}} <br v-if="data.Data.strasse.Content">
                                    {{data.Data.plz.Content}} {{data.Data.ort.Content}}
                                    <span v-if="data.Data.kanton.Content && data.Data.kanton.Content.length &&  data.Data.kanton.Content[0] >= 0" v-html="`/ ${$root.categories.kanton[data.Data.kanton.Content[0]]}`"></span><br>
                                    <span v-if="data.Data.land.Content && data.Data.land.Content.length && data.Data.land.Content[0] >= 0" v-html="$root.categories.land[data.Data.land.Content[0]]"></span>
                                </td>
                            </tr>


                            <tr v-if="data.Data.pseudonym">
                                <td v-html="$root.t(`fieldlabel:pseudonym`)"></td>
                                <td>
                                    <p v-for="l in data.Data.pseudonym.Content" v-html="l"></p>
                                </td>
                            </tr>

                            <tr v-if="data.Data.geburtsdatum && data.Data.geburtsdatum_genauigkeit.Content && data.Data.geburtsdatum_genauigkeit.Content[0] != -1">
                                <td v-html="$root.t(`fieldlabel:geburtsdatum`)"></td>
                                <td >{{data.Data.geburtsdatum.Content | dateformat(data.Data.geburtsdatum_genauigkeit.Content[0])}}</td>
                            </tr>

                            <tr v-if="data.Data.todesdatum && data.Data.todesdatum_genauigkeit.Content[0] != -1">
                                <td v-html="$root.t(`fieldlabel:todesdatum`)"></td>
                                <td >{{data.Data.todesdatum.Content | dateformat(data.Data.todesdatum_genauigkeit.Content[0])}}</td>
                            </tr>

                            <tr v-for="(d,k) in data.Data">
                                <template v-if="d.Content && ['geburtsort', 'adsmitglied'].indexOf(k) !== -1">
                                    <td v-html="$root.t(`fieldlabel:${k}`)"></td>
                                    <td v-if="k === 'adsmitglied'" v-html="$root.t(`entry:adsmitglied:${d.Content}`)"></td>
                                    <td v-if="k === 'geburtsort'" v-html="d.Content"></td>
                                </template>
                            </tr>

                            <tr v-if="data.Data.literarischesprache.Reference">
                                <td v-html="$root.t(`fieldlabel:literarischesprache`)"></td>
                                <td>
                                    <p v-for="ls in data.Data.literarischesprache.Content"  v-html="$root.categories.languages_byid[ls].translation[$root.language]"></p>
                                </td>
                            </tr>

                            <tr v-if="data.Data.internet.Content && data.Data.internet.Content.length > 0">
                                <td v-html="$root.t('entry:linkblock:web')"></td>
                                <td><a v-for="l in data.Data.internet.Content" :href="`${l[0].substr(0,4)!='http'?'http://':''}${l[0]}`" target="_blank" v-html="l[1]"></a></td>
                            </tr>


                            <tr v-if="data.Data.socialmedia && data.Data.socialmedia.Content && (data.Data.socialmedia.Content[0][0] || data.Data.socialmedia.Content[1][0])">
                                <td v-html="$root.t('entry:linkblock:socialmedia')"></td>
                                <td>
                                    <template v-for="l in data.Data.socialmedia.Content">
                                        <a  v-bind:key="`${l[1]}-${l[0]}`" v-if="['Facebook','Twitter','Instagram'].indexOf(l[1]) !== -1 && l[0]" :href="`//${l[1].toLowerCase()}.com/${l[0]}`" target="_blank" v-html="l[1]"></a>
                                    </template>
                                </td>
                            </tr>

                            <tr v-if="data.Data.email.Content">
                                <td v-html="$root.t('entry:linkblock:email')"></td>
                                <td><a :href="`mailto:${data.Data.email.Content}`" v-html="data.Data.email.Content"></a></td>
                            </tr>

                        </table>

                        <div class="entry-block">
                            <div class="entry-float-title"  v-on:click="re_toggle = !re_toggle">
                                <span  v-html="$root.t('entry:title:ressourcen')"></span>
                                <a :class="{'up': re_toggle, 'down': !re_toggle}"></a>
                            </div>
                            <transition name="entry-block">
                                <div v-if="re_toggle">
                                    <p style="margin-top: 0;" v-if="data.Data.bio && data.Data.bio.Parsed" v-html="data.Data.bio.Parsed.replace(/\\r\\n/g,'<br>')"></p>
                                    <p v-if="data.Data.bemerkungen && data.Data.bemerkungen.Parsed" v-html="data.Data.bemerkungen.Parsed.replace(/\\r\\n/g,'<br>')"></p>
                                </div>
                            </transition>
                        </div>

                        <div class="entry-block" v-if="data.Data.angebote && data.Data.angebote.Content && data.Data.angebote.Content.length > 0">
                            <div class="entry-float-title"  v-on:click="an_toggle = !an_toggle">
                                <span  v-html="$root.t('entry:titel:services')"></span>
                                <a :class="{'up': an_toggle, 'down': !an_toggle}"></a>
                            </div>
                            <transition name="entry-block">
                                <div class="entry-taglist" v-if="an_toggle">
                                    <div class="entry-taglist-tag" v-for="(d,k) in data.Data.angebote.Content" v-html="$root.categories.services_byid[d].translation[$root.language]"/>
                                </div>
                            </transition>
                        </div>
                        
                        <div class="entry-block" v-if="(data.Data.zielsprache && data.Data.zielsprache.Content && data.Data.zielsprache.Content.length > 0) || data.Data.quellsprache && data.Data.quellsprache.Content && data.Data.quellsprache.Content.length > 0">
                            <div class="entry-float-title"  v-on:click="se_toggle = !se_toggle">
                                <span v-html="$root.categories.services_byid[619].translation[$root.language]"></span>
                                <a :class="{'up': se_toggle, 'down': !se_toggle}"></a>
                            </div>
                            <transition name="entry-block">
                            <div class="entry-taglist" v-if="se_toggle">
                                    <table class="entry-taglist-translationtable">
                                        <tr>
                                            <td>
                                                <div class="entry-taglist-tag" v-for="(d,k) in data.Data.quellsprache.Content" v-html="$root.categories.languages_byid[d].translation[$root.language]"/>
                                            </td>
                                            <td>
                                                <a class="next"/>
                                            </td>
                                            <td>
                                                <div class="entry-taglist-tag" v-for="(d,k) in data.Data.zielsprache.Content" v-html="$root.categories.languages_byid[d].translation[$root.language]"/>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </transition>                        
                        </div>    

                        
                        <div class="entry-block" v-if="data.Contribution.ReferencedFrom && data.Contribution.ReferencedFrom.length > 0 && data.Contribution.ReferencedFrom.filter(a => {return a.Contribution.FortemplateName == 'SecondaryLiterature'}).length > 0">
                            <div class="entry-float-title"  v-on:click="sk_toggle = !sk_toggle">
                                <span  v-html="$root.t('entry:sekundärliteratur')"></span>
                                <a :class="{'up': sk_toggle, 'down': !sk_toggle}"></a>
                            </div>
                            <transition name="entry-block">
                                <table class="entry-table" v-if="sk_toggle">
                                    <tr v-bind:key="rkey" v-for="(r, rkey) in data.Contribution.ReferencedFrom" v-if="r.Contribution.Status == 'Close' && r.Contribution.FortemplateName == 'SecondaryLiterature'">
                                        <td>
                                            <router-link :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`">
                                            {{r.Contribution.Name}}
                                            </router-link>
                                        </td>
                                        <td style="text-align: right; width: 150px;">
                                            <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span>
                                        </td>
                                    </tr>
                                </table>
                            </transition>
                        </div>


                        <div class="entry-block" v-if="data">
                            <div class="entry-float-title"  v-on:click="toggleFooter()">
                            <span v-html="$root.t('entry:medienliste:titel')"></span>
                            <a :class="{'up': footertoggle, 'down': !footertoggle}"></a>
                            </div>
                            <transition name="entry-block">
                                <table class="entry-tableresources" v-if="footertoggle">
                                    <router-link :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`" tag="tr" v-for="(r,rkey) in data.Contribution.ReferencedFrom" v-if="r.Data.titel && r.Contribution.Status == 'Close' && r.Contribution.FortemplateName != 'SecondaryLiterature'">
                                        <td v-if="r.Data.genre && r.Data.genre.Content && r.Data.genre.Content.length">
                                            <span v-for="g in r.Data.genre.Content" class="label" v-html="$root.categories.genres_byid[g].translation[$root.language]"></span> 
                                        </td>
                                        <td v-if="r.Data.genre && (!r.Data.genre.Content || !r.Data.genre.Content.length)">
                                            <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span> 
                                        </td>
                                        <td v-if="r.Data.medientyp">
                                            <span v-for="g in r.Data.medientyp.Content" class="label" v-html="$root.categories.mediatypes_byid[g].translation[$root.language]"></span>
                                        </td>

                                        <td v-html="$root.j([r.Data.titel.Parsed, r.Data.untertitel ? r.Data.untertitel.Parsed : '', r.Data.erscheinungsjahr ? $options.filters.dateformat(r.Data.erscheinungsjahr.Content,1) : ''], ', ')">
                                        </td>
                                    </router-link>
                                    <template v-if="resources_loading === true">
                                        <tr>
                                            <td colspan="2" class="loader" v-html="$root.t('entry:loaded:resources')">
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else-if="data.Resources">
                                        <tr>
                                            <td colspan="2" class="loaded" v-html="$root.t('entry:loaded:resources')">
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="data.Resources &&  data.Resources.helveticat && data.Resources.helveticat.length > 0">
                                        <tr v-for="r in data.Resources.helveticat">
                                            <td>
                                            <span class="label">Helveticat</span>
                                            </td>
                                            <td>
                                                <a :href="`https://nb-helveticat.primo.exlibrisgroup.com/discovery/search?vid=41SNL_51_INST:helveticat&query=any,contains,${r.link}&lang=${$root.language_full}`" target="_blank">
                                                    <span v-if="r.title" v-html="r.title"></span>
                                                    <span v-if="r.date" v-html="`, ${r.date}`"></span>
                                                    <span v-if="r.function" v-html="` [${r.function}]`"></span>
                                                </a>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-if="data.Resources && data.Resources.viaf && data.Resources.viaf.length">
                                        <tr v-for="(r,rk) in data.Resources.viaf" v-bind:key="`viaf${rk}`">
                                            <td>
                                                <span class="label">{{$root.j(r.sources.s,'/')}}</span>
                                            </td>
                                            <td>
                                                <a  v-html="r.title" :href="`https://www.worldcat.org/search?q=ti%3A${r.title}+au%3A${data.Data.name.Content}`" target="_blank"></a>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else-if="data.Resources">
                                        <tr>
                                            <td colspan="2" class="loaded small" v-html="$root.t('entry:loaded:edited')">
                                            </td>
                                        </tr>
                                    </template>

                                </table>
                            </transition>
                        </div>


                    </div>
                </div>

        </template>
    
        <template v-if="$route.params.view === 'Book'">
            <div class="container container-small" v-if="data">
                <div class="entry-float entry-float-sidebar">
                    <Literaturschweiz v-bind:term="data.Data.titel.Content"/>
                </div>
                <div class="entry-float entry-float-maincontent">
                    <h1>
                        <span v-html="data.Data.titel.Content"/>
                        <span v-if="data.Data.untertitel.Content"><br>{{data.Data.untertitel.Content}}</span>   
                    </h1>

                    <p v-if="data.Data.werkref.Content && data.Data.werkref.Content.length && data.Data.werkref.Reference && data.Data.werkref.Reference[data.Data.werkref.Content[0]]">
                        <span v-html="$root.t('entry:bearbeitungvon')+': '"></span>
                        <router-link class="textlink" :to="`/Book/${aid}`" v-for="(aid, aik) in data.Data.werkref.Content"
                        v-html="$root.j([data.Data.werkref.Reference[aid].titel.Content, data.Data.werkref.Reference[aid].untertitel ? data.Data.werkref.Reference[aid].untertitel.Content : '', data.Data.werkref.Reference[aid].erscheinungsjahr ? $options.filters.yearformat(data.Data.werkref.Reference[aid].erscheinungsjahr.Content) : ''], ', ')"
                        >
                        </router-link>
                    </p>

                    <p v-if="data.Data.autor.Content && data.Data.autor.Content.length">
                        <span v-html="$root.t('entry:autorfullname')+': '"></span>
                        <router-link class="textlink" :to="`/Person/${aid}`"  v-for="(aid,aik) in data.Data.autor.Content" 
                        v-html="$root.j([data.Data.autor.Reference[aid].vorname.Content,data.Data.autor.Reference[aid].name.Content],' ')"
                        >
                        </router-link>
                    </p>
                    <p v-if="data.Data.coautor.Content && data.Data.coautor.Content.length">
                        <span v-html="$root.t('extended_form:werk:coautor')+': '"></span>
                        <router-link class="textlink" :to="`/Person/${aid}`"  v-for="(aid, aik) in data.Data.coautor.Content" 
                        v-html="$root.j([data.Data.coautor.Reference[aid].vorname.Content,data.Data.coautor.Reference[aid].name.Content],' ')"
                        >
                        </router-link>
                    </p>
                    <p v-if="data.Data.herausgeber.Content && data.Data.herausgeber.Content.length">
                        <span v-html="$root.t('extended_form:werk:herausgeber')+': '"></span>
                        <router-link class="textlink" :to="`/Person/${aid}`" v-for="(aid, aik) in data.Data.herausgeber.Content" 
                        v-html="$root.j([data.Data.herausgeber.Reference[aid].vorname.Content,data.Data.herausgeber.Reference[aid].name.Content],' ')"
                        >
                        </router-link>
                    </p>
                    <p v-if="data.Data.uebersetzer.Content && data.Data.uebersetzer.Content.length">
                        <span v-html="$root.t('extended_form:werk:uebersetzer')+': '"></span>
                        <router-link class="textlink" :to="`/Person/${aid}`" v-for="(aid, aik) in data.Data.uebersetzer.Content" 
                        v-html="$root.j([data.Data.uebersetzer.Reference[aid].vorname.Content,data.Data.uebersetzer.Reference[aid].name.Content],' ')"
                        >
                        </router-link>
                    </p>
                    
                    <p>
                        <span v-if="data.Data.intitel.Parsed" v-html="`${$root.t('entry:erschienen_in')}: ${data.Data.intitel.Parsed}<br>`"></span>
                        <span v-if="data.Data.ausgaben.Parsed" v-html="`${data.Data.ausgaben.Parsed}<br>`"></span>
                        <span  v-html="`${$root.j([data.Data.verlag.Parsed,data.Data.ort.Parsed, $options.filters.yearformat(data.Data.erscheinungsjahr.Content)],', ')}<br>`"></span>
                        <span v-if="data.Data.isbn.Parsed" v-html="`ISBN ${data.Data.isbn.Parsed} <br>`"></span>
                        <br>
                        <span v-if="data.Data.textsprache && data.Data.textsprache.Content && data.Data.textsprache.Content[0]" v-html="`${$root.t('extended_form:werk:textsprache')}: ${$root.categories.languages_byid[data.Data.textsprache.Content[0]].translation[$root.language]}<br>`"></span>
                        <span v-if="data.Data.genre && data.Data.genre.Content" v-for="(aid, aik) in data.Data.genre.Content" v-html="`${$root.t('extended_form:werk:buch:genre:literatur')}: ${$root.categories.genres_byid[aid].translation[$root.language]}<br>`"></span>
                    </p>

                    <p v-if="data.Data.info.Parsed" v-html="data.Data.info.Parsed"/>


                    <div class="entry-block" v-if="data.Contribution.ReferencedFrom && data.Contribution.ReferencedFrom.length > 0">
                        <div class="entry-float-title"  v-on:click="re_toggle = !re_toggle">
                            <span  v-html="$root.t('entry:referenzen')"></span>
                            <a :class="{'up': re_toggle, 'down': !re_toggle}"></a>
                        </div>
                        <transition name="entry-block">
                            <table class="entry-table" v-if="re_toggle">
                                <tr v-bind:key="rkey" v-for="(r, rkey) in data.Contribution.ReferencedFrom" v-if="r.Contribution.Status == 'Close'">
                                    <td>
                                        <router-link :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`">
                                        {{r.Contribution.Name}}
                                        </router-link>
                                    </td>
                                    <td style="text-align: right; width: 150px;">
                                        <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span>
                                    </td>
                                </tr>
                            </table>
                        </transition>
                    </div>

                    <div class="entry-block" v-if="data">
                        <div class="entry-float-title"  v-on:click="loadMoreBooks()">
                            <span v-html="$root.t('entry:medienliste:alle_titel_autor')"></span>
                            <a :class="{'up': morebooks, 'down': !morebooks}"></a>
                        </div>
                        <transition name="entry-block">
                            <table class="entry-tableresources entry-tableresources-three" v-if="morebooks">
                                <template v-if="moretitles">
                                    <router-link v-if="moretitles" :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`" tag="tr" v-for="(r,rkey) in moretitles.Documents">
                                        <td>
                                            <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span>
                                        </td>
                                        <td>
                                            <span v-if="r.Data.autor && intersect(persons, r.Data.autor.Content) > 0" class="label" v-html="$root.t('entry:autor')"></span>
                                            <span v-if="r.Data.coautor && intersect(persons, r.Data.coautor.Content) > 0" class="label" v-html="$root.t('entry:coautor')"></span>
                                            <span v-if="r.Data.herausgeber && intersect(persons, r.Data.herausgeber.Content) > 0" class="label" v-html="$root.t('entry:herausgeber')"></span>
                                            <span v-if="r.Data.uebersetzer && intersect(persons, r.Data.uebersetzer.Content) > 0" class="label" v-html="$root.t('entry:uebersetzer')"></span>
                                        </td>
                                        <td  v-html="$root.j([r.Data.titel.Parsed, r.Data.untertitel ? r.Data.untertitel.Parsed : ''],', ')"></td>                                    
                                    </router-link>
                                </template>
                                <tr v-else>
                                    <td colspan="3" class="loader" v-html="$root.t('entry:load:more')">
                                    </td>
                                </tr>
                            </table>
                        </transition>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="$route.params.view === 'Media'">
            <div class="container container-small" v-if="data">
                <div class="entry-float entry-float-sidebar">
                    <Literaturschweiz v-bind:term="data.Data.titel.Content"/>
                </div>
                <div class="entry-float entry-float-maincontent">
                    <h1>
                        <span v-html="data.Data.titel.Content"/>
                        <span v-if="data.Data.untertitel.Content"><br>{{data.Data.untertitel.Content}}</span>   
                    </h1>

                    <p v-if="data.Data.werkref.Content && data.Data.werkref.Content.length && data.Data.werkref.Reference && data.Data.werkref.Reference[data.Data.werkref.Content[0]]">
                        <span v-html="$root.t('entry:bearbeitungvon')+': '"></span>
                        <router-link class="textlink" :to="`/Book/${aid}`" v-for="(aid, aik) in data.Data.werkref.Content" v-html="$root.j([data.Data.werkref.Reference[aid].titel.Content, data.Data.werkref.Reference[aid].untertitel ? data.Data.werkref.Reference[aid].untertitel.Content : '', data.Data.werkref.Reference[aid].erscheinungsjahr ? $options.filters.yearformat(data.Data.werkref.Reference[aid].erscheinungsjahr.Content) : ''], ', ')"></router-link>
                    </p>


                    <p v-if="data.Data.autor.Content && data.Data.autor.Content.length">
                        <span v-html="$root.t('entry:autorfullname')+': '"></span>
                        <router-link  v-for="(aid,aik) in data.Data.autor.Content" class="textlink" :to="`/Person/${aid}`" v-html="$root.j([data.Data.autor.Reference[aid].vorname.Content,data.Data.autor.Reference[aid].name.Content],' ')"></router-link>
                    </p>

                    
                    <p>
                        <span v-if="data.Data.info.Parsed" v-html="`${data.Data.info.Parsed}<br>`"></span>
                        <span v-if="data.Data.erscheinungsjahr.Content" v-html="`${$options.filters.yearformat(data.Data.erscheinungsjahr.Content)}<br>`"></span>
                        <span v-if="data.Data.ean.Parsed" v-html="`EAN/ISBN ${data.Data.ean.Parsed} <br>`"></span>
                        <br>
                        <span v-for="(aid, aik) in data.Data.medientyp.Content" v-html="`${$root.t('extended_form:werk:andere:genre:medientyp')}: ${$root.categories.mediatypes_byid[aid].translation[$root.language]}<br>`"></span>
                    </p>

                    <p v-if="data.Data.notes.Parsed" v-html="data.Data.notes.Parsed"/>


                    <div class="entry-block" v-if="data.Contribution.ReferencedFrom && data.Contribution.ReferencedFrom.length > 0">
                        <div class="entry-float-title"  v-on:click="re_toggle = !re_toggle">
                            <span  v-html="$root.t('entry:referenzen')"></span>
                            <a :class="{'up': re_toggle, 'down': !re_toggle}"></a>
                        </div>
                        <transition name="entry-block">
                            <table class="entry-table" v-if="re_toggle">
                                <tr v-bind:key="rkey" v-for="(r, rkey) in data.Contribution.ReferencedFrom" v-if="r.Contribution.Status == 'Close'">
                                    <td>
                                        <router-link :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`">
                                        {{r.Contribution.Name}}
                                        </router-link>
                                    </td>
                                    <td style="text-align: right; width: 150px;">
                                        <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span>
                                    </td>
                                </tr>
                            </table>
                        </transition>
                    </div>

                    <div class="entry-block" v-if="data">
                        <div class="entry-float-title"  v-on:click="loadMoreBooks()">
                            <span  v-html="$root.t('entry:medienliste:alle_titel_autor')"></span>
                            <a :class="{'up': morebooks, 'down': !morebooks}"></a>
                        </div>
                        <transition name="entry-block">
                            <table class="entry-tableresources entry-tableresources-three" v-if="morebooks">
                                <template v-if="moretitles">
                                    <router-link :to="`/${r.Contribution.FortemplateName}/${r.Contribution.Id}`" tag="tr" v-for="(r,rkey) in moretitles.Documents">
                                        <td>
                                            <span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span>
                                        </td>
                                        <td>
                                            <span class="label" v-html="$root.t('entry:autor')" v-if="r.Data.autor && intersect(persons, r.Data.autor.Content) > 0"></span>
                                            <span class="label" v-html="$root.t('entry:coautor')" v-if="r.Data.coautor && intersect(persons, r.Data.coautor.Content) > 0"></span>
                                            <span class="label" v-if="r.Data.herausgeber && intersect(persons, r.Data.herausgeber.Content) > 0" v-html="$root.t('entry:herausgeber')"></span>
                                            <span class="label" v-html="$root.t('entry:uebersetzer')" v-if="r.Data.uebersetzer && intersect(persons, r.Data.uebersetzer.Content) > 0"></span>
                                        </td>
                                        <td  v-html="$root.j([r.Data.titel.Parsed, r.Data.untertitel ? r.Data.untertitel.Parsed : ''],', ')"></td>

                                    </router-link>
                                </template>
                                <tr v-else>
                                    <td colspan="3" class="loader" v-html="$root.t('entry:load:more')">
                                    </td>
                                </tr>
                            </table>
                        </transition>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="$route.params.view === 'SecondaryLiterature'">
            <div class="container container-small" v-if="data">
                <div class="entry-float entry-float-sidebar">
                    <Literaturschweiz v-bind:term="data.Data.titel.Content"/>
                </div>
                <div class="entry-float entry-float-maincontent">
                    <h1>
                        <span v-html="data.Data.titel.Content"/>
                    </h1>  
                    <p v-if="data.Data.name.Content" v-html="data.Data.name.Content"></p>
                    <p v-if="data.Data.intitel.Content" v-html="data.Data.intitel.Content"></p>
                    <p v-if="data.Data.quelle.Content" v-html="data.Data.quelle.Content"></p>

                    <div class="entry-block" v-if="data">
                        <div class="entry-float-title"  v-on:click="toggleFooter()">
                            <span v-html="$root.t('entry:sekundärliteratur:zu')"></span>
                            <a :class="{'up': footertoggle, 'down': !footertoggle}"></a>
                        </div>
                        <transition name="entry-block">
                            <table class="entry-tableresources" v-if="footertoggle">
                                <router-link :to="`/Book/${aid}`" tag="tr"  v-for="(aid, aik) in data.Data.werkref.Content" v-if="aid != -1">
                                    <td>
                                    <span class="label" v-html="$root.t(`template:Book`)"></span>
                                    </td>
                                    <td v-html="$root.j([data.Data.werkref.Reference[aid].titel.Content, data.Data.werkref.Reference[aid].untertitel ? data.Data.werkref.Reference[aid].untertitel.Content : ''], ' ')">
                                    </td>
                                </router-link>
                                <router-link :to="`/Person/${aid}`" tag="tr"  v-for="(aid, aik) in data.Data.autor.Content"  v-if="aid != -1">
                                    <td>
                                    <span class="label" v-html="$root.t(`template:Person`)"></span>
                                    </td>
                                    <td v-html="$root.j([data.Data.autor.Reference[aid].vorname.Content, data.Data.autor.Reference[aid].name.Content], ' ')">
                                    </td>
                                </router-link>   
                            </table>
                        </transition>
                    </div>                       
                </div>
            </div>
        </template>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .entry {;
    .fade-enter-active {
      transition: opacity .5s;
    }
    .fade-leave-active {
      position: absolute;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    img {
        max-width: 100%;
        @include sm() {
            max-height: 40vh;
            display: block;
            margin: auto;
        }
    }

    figure {
        margin: 0;
        padding: 0;
        width: calc(100% - 1em);
        height: 30vh;
        position: relative;
        padding: $padding/2;
        background: $background-highlight;
        display: block;
        img {
            display: block;            
            max-width: 100%;
            max-height: 100%;
            margin: auto;
        }
    }

    &-block {
        clear:both;
        border-top: 1px solid;
        &:last-child {
            border-bottom: 1px solid;
        }
        .entry-float-title {
            padding: $padding 0;
            margin-bottom: 0em;
        }
        &-visible {
            max-height: 200px;
        }

        &-enter-active, &-leave-active {
            transition: opacity .5s;
        }
        &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }

    }

    &-taglist {
        @include smallfont();
        margin-bottom: $padding;
        &-tag {
            background: $dark-color;
            display: inline-block;
            padding: $padding / 2 $padding;
            margin-bottom: $padding / 2;
            margin-right: $padding / 2;
        }
        &-translationtable {
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            tr {
                vertical-align: center;
            }
            td:last-child {
                text-align: right;
                .entry-taglist-tag {
                    margin-right: 0 !important;
                    margin-left: $padding / 2;            
                }
            }
            td:nth-child(2) {
                text-align: center;
                width: 2.3em;
                a {
                    float: none;
                    &:after {
                        left: 0;
                    }
                }
            }
        }
    }
    &-float {
        &:after {
            content: " ";
            display: block;
            clear: both;
        }
        &-sidebar {
            float: right;
            width: 25%;
            padding-left: $padding;    
            @include sm() {
                display: none;
            }        
        }
        &-maincontent {
            float: left;
            width: 75%;
            padding-right: $padding;
            border-right: 1px solid;
            min-height: calc(100vh - 9em);
            .textlink {
                border-bottom: 1px solid;
                margin-right: 0.5em;
            }
            @include sm() {
                width: 100%;
                float: none;
                border-right: none;
                padding-right: 0px;
                padding-top: $padding;
            }        
        }
        &-title {
            //@include smallfont();
            padding-bottom: $padding;
            cursor: pointer;
        }
        &-header {
            padding: $padding / 2 $padding / 2 $padding / 6 $padding / 2;
            margin-top: -$padding / 2;
            margin-right: -$padding / 2;
            margin-left: -$padding / 2;
            color: black;
            span {
             font-size: 0.5em;
             border-bottom: 1px solid;
             display: block;
             padding-bottom: $padding / 4;
             margin-bottom: $padding / 2;
            }
        }
    }

    &-table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: $padding;
      a, p {
          margin:0;
          padding: 0;
          display: block;
      }
      tr {
          
      }
      td {
        cursor: pointer;
        padding: 0;
        vertical-align: top;
        overflow: hidden;
        padding: $padding / 2 0;
        //@include smallfont();
        &:first-child {
            padding-bottom: 0;
        }
        &:last-child {
            
        }
      }
    }

    &-tableresources {
      width: 100%;
      
      margin-bottom: $padding;
      a, p {
          margin:0;
          padding: 0;
          display: block;
      }
      tr {
          
      }
      td {
        cursor: pointer;
        padding: 0;
        vertical-align: top;
        overflow: hidden;
        padding: $padding / 2 0;
        width: calc(100% - 40px);
        &:first-child {
            padding-bottom: 0;
            padding-right: $padding;
        }
        &.small {
            @include smallfont();
        }
      }
      &-three {
        td {
            width: auto;
            &:first-child, &:nth-child(2) {
                padding-bottom: 0;
                padding-right: $padding;
            }
            &:nth-child(3) {
                width: calc(100% - 160px);
            }
            @include sm() {
                &:nth-child(2) {
                    display: none;
                }   
            }
        }
      }
      .loader {
            background-image: url('~@/assets/images/spinner.svg');
            background-position:  right center;
            background-repeat: no-repeat;
            background-size: $padding * 1.5 $padding * 1.5;
            padding: $padding 0;
        } 
        .loaded {
            padding: $padding 0 !important;
        }
    }

  }
</style>

<script>

import Quicksearch from '@/components/Quicksearch.vue'
import Literaturschweiz from '@/components/Literaturschweiz.vue'
import StaticFooter from '@/components/StaticFooter.vue'
import Integrations from '@/components/Integrations.vue'

export default {
  name: 'entry',
  components: {
      Quicksearch,
      Literaturschweiz,
      StaticFooter,
      Integrations
  },
  data() {
    return {
        searching: true,
        data: null,
        footertoggle: false,
        morebooks: false,
        an_toggle: false,
        se_toggle: false,
        re_toggle: false,
        sk_toggle: false,
        moretitles: false,
        persons: [],
        resources_loading: false
    }
  },
  mounted() {
    this.fetchData()          
  },
  watch: {
    '$route' () {
        this.toggleFooter(true);
        this.an_toggle = false;
        this.se_toggle = false;
        this.re_toggle = false;
        this.sk_toggle = false;

        this.morebooks = false;
        this.moretitles = false;

        this.fetchData(); 
    }
  },
  methods: {
    async fetchData() {
        this.searching = true;
        this.data = null;
        this.data = await this.$store.dispatch('load', {mode: `/contribution/${this.$route.params.id}`});
        if (this.data.Contribution.FortemplateName != this.$route.params.view) {
            this.$route.params.view = this.data.Contribution.FortemplateName;
        }
        try {
            this.data.Data.pseudonym = false;   
            if (this.data.Data.pseudonym && this.data.Data.pseudonym.Content) {
                let _p = this.data.Data.pseudonym.Content;
                this.data.Data.pseudonym.Content = Object.keys(_p).map(function(key) {
                    return _p[key][0];
                });
                if (!this.data.Data.pseudonym.Content[0]) {
                    this.data.Data.pseudonym = false;
                }
            }
        } catch (error) {
            this.data.Data.pseudonym = false;   
        }
        try {
            this.data.adresse = false;
            if (this.data.Data.strasse.Content || 
                this.data.Data.plz.Content || 
                this.data.Data.ort.Content ||
                (this.data.Data.kanton.Content && this.data.Data.kanton.Content.length && this.data.Data.kanton.Content[0] >= 0) ||
                (this.data.Data.land.Content && data.Data.land.Content.length && data.Data.land.Content[0] >= 0)) {
                    this.data.adresse = true;
                }
            if (this.data.Data.kanton.Content && typeof this.data.Data.kanton.Content === "string") {
                this.data.Data.kanton.Content = [this.data.Data.kanton.Content*1];
            }
        } catch(error) {
            this.data.adresse = false;
        }

        try {
            let _sorted = this.data.Contribution.ReferencedFrom;
            _sorted = _.orderBy(_sorted, o => parseInt(o.Data.erscheinungsjahr ? o.Data.erscheinungsjahr.Content : true), 'desc');
            this.data.Contribution.ReferencedFrom = _sorted;
        }
        catch (err) {
            console.warn(err);
        }



        this.searching = false;
    },
    callback() {
        this.$router.push({ name: 'searchresults' })
    },
    async toggleFooter(force) {
        force = force || false;
        this.footertoggle = force === true ? false : !this.footertoggle
        const el = document.body;
        if (this.footertoggle === true) {
            if (this.data.Data.gndid && this.data.Data.gndid.Content && this.data.Resources === false) {
                this.resources_loading = true;
                let _r = await this.$store.dispatch('load', {mode: `/gnd/${this.data.Data.gndid.Content}`});
                this.resources_loading = false;
                this.data.Resources = _r.Resources;
            }
        }
    },
    intersect(a, b) {
        var t;
        try {
            if (b.length > a.length) t = b, b = a, a = t; // indexOf to loop over shorter
            return a.filter(function (e) {
                return b.indexOf(e) > -1;
            });
        } catch(err) {
            return false;
        }
    },
    async loadMoreBooks() {
        if (this.morebooks === true) {
            this.morebooks = false;
            this.moretitles = false;
            return;
        }
        let _q  = [];
        let _ff = [];
        let _fm = [];
        let _fields = ['autor','coautor','herausgeber','uebersetzer'];
        _fields.forEach(_f => {
            try {
              this.data.Data[_f].Content.forEach(__f => {
                  this.persons.push(__f);
                  [40,55,41,42,43].forEach(_fid => {
                    _q.push(__f);
                    _ff.push(_fid);
                    _fm.push('like');
                  })
              })  
            } catch (error) {
              console.warn(error)
            } 
        });

        this.morebooks = true;
        this.moretitles = await this.$store.dispatch('load', {mode: '/contributions/3/4-5', params: {data: `name|vorname|untertitel|titel|${_fields.join('|')}`, references: 'false', query: _q.join('|'), filter: `${_ff.join('|')}:${_fm.join('|')}`}});
        
    }
  }
}
</script>
